import * as core from '../../../../../../../core'
import * as innovationTracker from '../innovation-tracker'

export const RESOURCE = {
  payload: {
    alias: 'asset.tracker',
    appAlias: innovationTracker.RESOURCE.payload.alias,
    description: "Explore Attain's AI-Enabled assets",
    display: {
      isMain: true,
      position: 3,
    },
    name: 'Asset Tracker',
    page: { alias: 'asset.tracker' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
